import gql from 'graphql-tag';

const query = gql`
    query getCustomerAddresses {
        customer {
            defaultAddress {
                __typename
                id
                address1
                address2
                company
                city
                province
                zoneCode
                zip
                country
                phone: phoneNumber
            }
            addresses(first: 6) {
                edges {
                    node {
                        __typename
                        id
                        address1
                        address2
                        company
                        city
                        province
                        zoneCode
                        zip
                        country
                        phone: phoneNumber
                    }
                }
                pageInfo {
                    __typename
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
            }
        }
    }
`;

export { query };
